import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Text, Tag, ImageContainer, DateContainer, NewsContainer, NewsTitle, } from "../../Styles/SharedStyledComponents";
import { sliceStringAfterMaxLength } from "../../../../utils/Utils";
import { Row } from "../../shared-components/Ui/Row";
export var NewsCard = function (_a) {
    var _b;
    var item = _a.item;
    var langCode = ((_b = document.getElementById("language-code")) === null || _b === void 0 ? void 0 : _b.value) || "en";
    var urlPrefix = langCode == "fr" ? "/fr/nouvelles" : "/en/news";
    var formatDate = function (annee, mois, jour, dateCreation) {
        // Si les champs individuels ne sont pas disponibles, extraire depuis date_creation
        var jourToUse = jour;
        var moisToUse = mois;
        var anneeToUse = annee;
        // Si date_creation existe, l'utiliser pour remplir les champs manquants
        if (dateCreation) {
            var dateFromCreation = new Date(dateCreation);
            if (!isNaN(dateFromCreation.getTime())) {
                // Extraire le jour si manquant
                if (!jourToUse) {
                    jourToUse = dateFromCreation.getDate();
                }
                // Extraire le mois si manquant
                if (!moisToUse) {
                    moisToUse = dateFromCreation.getMonth() + 1;
                }
                // Extraire l'année si manquante
                if (!anneeToUse) {
                    anneeToUse = dateFromCreation.getFullYear();
                }
            }
        }
        if (!anneeToUse || !moisToUse)
            return "";
        // Options de formatage selon si le jour existe ou non
        var options = jourToUse
            ? { year: "numeric", month: "long", day: "numeric" }
            : { year: "numeric", month: "long" };
        var f = Intl.DateTimeFormat(langCode, options);
        // Pour créer la date, on utilise toujours un jour (le jour fourni ou le 1er du mois)
        var dateToFormat = jourToUse
            ? new Date("".concat(anneeToUse, "-").concat(moisToUse, "-").concat(jourToUse).replace(/-/g, "/"))
            : new Date("".concat(anneeToUse, "-").concat(moisToUse, "-01").replace(/-/g, "/"));
        if (isNaN(dateToFormat.getTime()))
            return "";
        var formattedDate = f.format(dateToFormat);
        // Capitaliser la première lettre du mois (trouver le premier mot qui commence par une lettre)
        return formattedDate.replace(/\b[a-zàâäéèêëïîôùûüÿç]/i, function (match) { return match.toUpperCase(); });
    };
    var hyperlink = function () {
        if (langCode === 'fr') {
            return item.hyperlink_fr || item.hyperlink_en;
        }
        else {
            return item.hyperlink_en || item.hyperlink_fr;
        }
    };
    return (_jsx(React.Fragment, { children: _jsx(NewsContainer, { children: _jsxs(Row, { children: [_jsx("div", { className: "col-md-5 ps-md-0 mb-3", children: _jsx("a", { href: hyperlink() ? hyperlink() : "".concat(urlPrefix, "/").concat(langCode === "fr" ? item.slug_fr : item.slug_en), target: hyperlink() ? "_blank" : "", rel: "noopener noreferrer", children: _jsx(ImageContainer, { marginBottom: 14, children: _jsx("img", { src: item.thumbnail_url ? item.thumbnail_url : process.env.IMG_URL + "/static/vendors/images/default-Image-company.png", alt: "banner" }) }) }) }), _jsx("div", { className: "col-md-7 mb-3 mb-md-0", children: _jsxs(Text, { children: [_jsx(DateContainer, { children: formatDate(item.date_creation_annee, item.date_creation_mois, item.date_creation_jour, item.date_creation) }), _jsx(NewsTitle, { children: _jsx("a", { href: hyperlink() ? hyperlink() : "".concat(urlPrefix, "/").concat(langCode === "fr" ? item.slug_fr : item.slug_en), target: hyperlink() ? "_blank" : "", rel: "noopener noreferrer", children: langCode === "fr" ? item.titre_fr : item.titre_en }) }), _jsx("p", { children: sliceStringAfterMaxLength(120, langCode === "fr" ? item.description_fr : item.description_en) }), _jsx("div", { children: item.categorie.map(function (cat) {
                                        return (_jsx("a", { href: "/".concat(langCode, "/").concat(langCode == "en" ? "news/" : "nouvelles/", "?category=").concat(cat.id), children: _jsx(Tag, { children: langCode == "fr" ? cat.nom_fr : cat.nom_en }) }, cat.id));
                                    }) })] }) })] }) }) }));
};
